import decodeJwt from 'jwt-decode';
import Permission from 'views/screens/users/Permmision';
//import { stringify } from 'query-string';
//import { AUTH_LOGIN, AUTH_LOGOUT  } from 'react-admin';
export default {
    login: ({ username, password }) => {
        const request = new Request('http://159.89.46.247:4000/users/login', {
            method: 'POST',
            body: JSON.stringify({ username, password }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });
        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    return Promise.reject();
                }
                return response.json();
            })
            .then(({ token }) => {
                // console.log(token)
                if (token) {
                    const decodedToken = decodeJwt(token);
                    // console.log(decodedToken)
                    const per = decodedToken.user.permissions;
                    // console.log(per)
                    const id = decodedToken.user.id;
                    localStorage.setItem('isLoggedIn', true);
                    localStorage.setItem('token', token);
                    // localStorage.setItem('permission', per);
                    localStorage.setItem("permission", JSON.stringify(per));
                    localStorage.setItem('userid', id);
                    // localStorage.setItem('permissions', token);
                    return Promise.resolve();
                }
                else {
                    localStorage.removeItem('isLoggedIn', true);
                    localStorage.removeItem('token');
                    localStorage.removeItem('permission');
                    // localStorage.removeItem('permissions');
                    return Promise.resolve();
                }

            });
    },
    logout: () => {
        localStorage.removeItem('isLoggedIn', true);
        localStorage.removeItem('token');
        localStorage.removeItem('permission');
        // localStorage.removeItem('permissions');
        return Promise.resolve();
    },
    checkError: ({ status }) => {
        if (status === 401 || status === 403) {
            localStorage.removeItem('token');
            return Promise.reject();
        }
        return Promise.resolve();
    },
    checkAuth: () => {
        // console.log('hj', localStorage.getItem('token'))
        return localStorage.getItem('token') ? Promise.resolve() : Promise.reject();
    },
};